import { styled } from 'styled-components';

export const LazyContainer = styled.div`
  min-height: ${({ $minHeight }) => `${$minHeight}px`};
`;
